// extracted by mini-css-extract-plugin
export default {"active":"Pay_active__6CUZO","inActive":"Pay_inActive__Q9sD4","box":"Pay_box__2sacF","iconWrapper":"Pay_iconWrapper__2WLFD","icon":"Pay_icon__nMDbX","label":"Pay_label__gjNc5"};